<script type="text/javascript">
  export default {};
</script>

<template>
  <div class="account-withdrawal-loader">
    <div class="account-withdrawal-loader__row account-withdrawal-loader__row--first">
      <div class="account-withdrawal-loader__row-col-1"></div>
      <div class="account-withdrawal-loader__row-col-2"></div>
    </div>
    <div class="account-withdrawal-loader__row">
      <div class="account-withdrawal-loader__row-col-1"></div>
      <div class="account-withdrawal-loader__row-col-2"></div>
    </div>
    <div class="account-withdrawal-loader__row">
      <div class="account-withdrawal-loader__row-col-1"></div>
      <div class="account-withdrawal-loader__row-col-2"></div>
    </div>
    <div class="account-withdrawal-loader__row">
      <div class="account-withdrawal-loader__row-col-1"></div>
      <div class="account-withdrawal-loader__row-col-2"></div>
    </div>
  </div>
</template>

<style lang="scss">
  .account-withdrawal-loader {
    @import '~styles/settings';

    background: $white;
    height: 280px;
    padding: 0 20px;
    margin-bottom: 15px;

    &__row {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      border-bottom: 1px solid $grey2;

      &-col-1 {
        @include text-line(110px, 9px);
      }

      &-col-2 {
        @include text-line(40px, 9px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/AccountWithdrawalLoader.vue